import {useEffect,useRef,useState} from 'react';
import {requestEmailSubscription,confirmEmailSubscription} from '../services/smsConsentService';

export function RequestEmailSubscription({gymSlug,email,disclosureVersion}) {
  const [busy,setBusy]=useState(false),[notice,setNotice]=useState(''),[error,setError]=useState('');
  const operation=useRef(null),lock=useRef(false),alive=useRef(true);
  useEffect(()=>{alive.current=true;return()=>{alive.current=false;};},[]);
  async function send(){
    if(lock.current)return;
    if(!operation.current){
      if(!globalThis.crypto?.randomUUID){setError('Refresh to create a secure request.');return;}
      operation.current={requestId:globalThis.crypto.randomUUID(),email,disclosureVersion};
    }
    lock.current=true;setBusy(true);setError('');
    try {
      const result=await requestEmailSubscription(gymSlug,operation.current);
      if(!alive.current)return;
      if(result.state==='email_link_sent')setNotice('Check your inbox. Open the link and confirm to subscribe to email updates.');
      else setError('Your gym needs to review this permission. Your unsubscribe remains in place.');
    }catch{if(alive.current)setError('The email could not be confirmed. Retry the same request, or contact your gym.');}
    finally{lock.current=false;if(alive.current)setBusy(false);}
  }
  return <div className="sms-capture-progress"><p>Email remains unsubscribed. Request a verification link sent to your email to subscribe again.</p>
    {notice?<p role="status">{notice}</p>:<button type="button" disabled={busy||!email} onClick={send}>{busy?'Sending…':error?'Retry subscription link':'Send subscription link'}</button>}
    {error&&<p role="alert">{error}</p>}
  </div>;
}
export default function EmailSubscriptionConfirmation({gymSlug,token,gym,onReturn}) {
  const [busy,setBusy]=useState(false),[result,setResult]=useState(null),[error,setError]=useState(''),[terminal,setTerminal]=useState(false);
  const lock=useRef(false),alive=useRef(true);
  useEffect(()=>{alive.current=true;return()=>{alive.current=false;};},[]);
  async function confirm(){
    if(lock.current)return;lock.current=true;setBusy(true);setError('');
    try {const receipt=await confirmEmailSubscription(gymSlug,{token,affirmative:true});if(alive.current)setResult(receipt);}
    catch(failure){if(alive.current){const status=failure?.response?.status,closed=[400,403,404,409,410].includes(status);setTerminal(closed);setError(status===410?'This link expired. Return to the contact form to request a new one.':closed?'This link is unavailable or your preference changed. Return to the contact form to request a new link.':'Your subscription could not be confirmed. Retry Confirm to check the same request.');}}
    finally{lock.current=false;if(alive.current)setBusy(false);}
  }
  return <main className="sms-capture"><section className="sms-capture-card"><div className="sms-capture-mark">M</div><p className="sms-capture-eyebrow">{gym.organizationName}</p><h1>Email preferences</h1>
    {result?<p role="status">{result.emailConsent?.status==='subscribed'?'Your email subscription is confirmed.':'You remain unsubscribed. Request a new link if you want to subscribe again.'}</p>:<>
      <p>{gym.disclosure.emailText}</p><p>Choose Confirm to subscribe to this gym’s email updates. You can unsubscribe at any time.</p>
      <button type="button" disabled={busy||terminal||!gym.disclosure.emailText} onClick={confirm}>{busy?'Saving…':'Confirm email subscription'}</button>
    </>}
    {error&&<p role="alert">{error}</p>}<button type="button" className="secondary" disabled={busy} onClick={onReturn}>Return to contact form</button>
  </section></main>;
}
